const { GET_FOLDER_REQUEST, GET_FOLDER_SUCCESS } = require("../constant")

const initial={
    folders:[],
    isLoading:false,
    isDone:false,
}
export const FolderReducer=(state=initial,action)=>{
    switch(action.type){
        case GET_FOLDER_REQUEST:
            return {
                ...state,
                isLoading:true,
            }
            case GET_FOLDER_SUCCESS:
                return {
                    ...state,
                    folders:action.payload,
                    isDone:true,
                    isLoading:false,
                }
                default:
                    return state
    }
}